import {DAY_MS, iso, makeShareToken, EUROPE_COUNTRIES, MOCK_ICCID, MOCK_DOMAIN_ID, MOCK_ACTIVATION_CODE, MOCK_RESELLER_INFORMATION} from "./shared";

// "Low data, good validity" demo: installed, ~33% of validity elapsed (still
// comfortably green), but only 819.2 MB of 10 GB left (~8%, under the 20% low-data
// threshold) - the data ring should warn while the expiry bar stays calm,
// demonstrating the two are computed independently of one another.
// Note the MB unit: below 1 GB the server switches availableBalance to MB while
// size stays in GB, so this scenario also covers the cross-unit comparison.
function dates() {
    return {
        activatedAt: iso(-10 * DAY_MS),
        expiresAt: iso(-10 * DAY_MS + 30 * DAY_MS),
        salesDate: iso(-10 * DAY_MS - 60 * 60 * 1000)
    };
}

export function getMockCustomerProfile() {
    const {activatedAt, expiresAt, salesDate} = dates();

    return {
        totalAvailableBalance: {sizeValue: 819.2, sizeUnit: "MB"},
        balances: [
            {
                price: {priceValue: 14.99, currencyCode: "USD"},
                salesDate,
                customerProfileDomainId: MOCK_DOMAIN_ID,
                includedCountries: EUROPE_COUNTRIES,
                balance: {
                    name: "Europe Data Pack",
                    activatedAt,
                    expiresAt,
                    activationMode: "NOW",
                    size: {sizeValue: 10, sizeUnit: "GB"},
                    availableBalance: {sizeValue: 819.2, sizeUnit: "MB"},
                    validitySize: 30, validityUnit: "days",
                    countrySet: "eur",
                    extendedDataPolicy: null
                }
            }
        ],
        relatedEsims: [
            {
                uid: "esim-uid-002",
                active: true,
                state: "Installed",
                iccid: MOCK_ICCID,
                customerProfileDomainId: MOCK_DOMAIN_ID,
                activatedAt,
                lastSeen: iso(-30 * 60 * 1000),
                installationUrl: `https://example.com/esim?token=${makeShareToken(MOCK_ICCID)}`,
                appleUniversalLink: "https://example.com/esim/apple-install",
                androidUniversalLink: "https://example.com/esim/android-install",
                activationCode: MOCK_ACTIVATION_CODE,
                imsi: ""
            }
        ],
        resellerInformation: MOCK_RESELLER_INFORMATION
    };
}

export function getMockEsimData() {
    const {activatedAt, expiresAt} = dates();

    return {
        esimProfile: {
            uid: "esim-uid-002",
            active: true,
            state: "Installed",
            iccid: MOCK_ICCID,
            customerProfileDomainId: MOCK_DOMAIN_ID,
            activatedAt,
            lastSeen: iso(-30 * 60 * 1000),
            installationUrl: `https://example.com/esim?token=${makeShareToken(MOCK_ICCID)}`,
            appleUniversalLink: "https://example.com/esim/apple-install",
            androidUniversalLink: "https://example.com/esim/android-install",
            activationCode: MOCK_ACTIVATION_CODE,
            imsi: ""
        },
        balances: [
            {
                name: "Europe Data Pack",
                activatedAt,
                expiresAt,
                activationMode: "NOW",
                size: {sizeValue: 10, sizeUnit: "GB"},
                availableBalance: {sizeValue: 819.2, sizeUnit: "MB"},
                validitySize: 30, validityUnit: "days",
                countrySet: "eur",
                extendedDataPolicy: null
            }
        ],
        totalAvailableBalance: {sizeValue: 819.2, sizeUnit: "MB"},
        customerProfileUrl: "https://example.com/customer/profile?token=mock-customer-token",
        resellerInformation: MOCK_RESELLER_INFORMATION
    };
}
